import React from 'react';
import { ProjectKeywordGq } from '../../../../../graphql/projects/models/ProjectKeywordGq';
import VoxelLoadingSpinner from '../../../../voxel/Animation/VoxelLoadingSpinner';
import VoxelDataTableCell from '../../../../voxel/DataTable/VoxelDataTableCell';

export interface TableCellQuarterPeakProps {
  keyword: ProjectKeywordGq;
}

const TableCellQuarterPeak: React.FC<TableCellQuarterPeakProps> = React.memo(({ keyword }) => {
  const quarter = keyword.peakQuarter;

  return (
    <VoxelDataTableCell align="center">
      {keyword.fetchingNewVolume ? (
        <div className="flex flex-row justify-center items-center gap-2 flex-nowrap">
          <VoxelLoadingSpinner />
        </div>
      ) : (
        quarter !== null && 'Q' + quarter
      )}
    </VoxelDataTableCell>
  );
});

export default TableCellQuarterPeak;
